import { getArrayTableCurrentRowByField, handleSelectDataSource, handleSelectRequestConfig, handleRequestExtraConfig, getRealRequestUrl, } from '@/common/util/util';
import { CnTreeSelect, componentMap as formComponentMap, formilyReact, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
import isPlainObject from 'lodash/isPlainObject';
import { handleRequestParams, handleResultProcessFunc, } from '@/common/util/request';
import { useRef } from 'react';
import { formComponentRefStorage } from '@/common/util/const';
import { __arrayTableCurrentRow__, componentRefSplit, } from '@/common/util/expr-const';
const { useField } = formilyReact;
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'TreeSelect',
    component: CnTreeSelect,
    formComponent: (props) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const realRef = useRef(null);
        const { _dataSourceName } = props || {};
        const params = props?.requestConfig?.params;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const field = useField?.();
        if (Array.isArray(params) && params?.length > 0) {
            let _params = {};
            const { getRequestParams } = props;
            if (typeof getRequestParams === 'function') {
                _params = getRequestParams();
            }
            if (typeof field?.index === 'number') {
                const temp = field.query('..').value();
                const currentRow = temp?.[field.index];
                if (isPlainObject(currentRow)) {
                    _params.tableCurrentRow = currentRow;
                }
            }
            _params.getExtraParam = () => {
                return {
                    [__arrayTableCurrentRow__]: 
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    getArrayTableCurrentRowByField(useField?.()) || {},
                };
            };
            _params.extraParamList = [
                {
                    [__arrayTableCurrentRow__]: 
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    getArrayTableCurrentRowByField(useField?.()) || {},
                },
            ];
            props.requestConfig.formatParam = (oldParams) => {
                if (typeof _params?.getFormInstance === 'function') {
                    const temp = _params.getFormInstance()?.values;
                    if (isPlainObject(temp)) {
                        _params.recordDataSource = temp;
                    }
                }
                const realParams = handleRequestParams(params, { ..._params });
                return { ...oldParams, ...realParams };
            };
            delete props.requestConfig.params;
        }
        const extraProps = {
            getRequestParams: undefined,
        };
        // handleFormUrlencodedData(props?.requestConfig);
        const fieldEntire = field?.path?.entire;
        if (_dataSourceName && fieldEntire && realRef) {
            formComponentRefStorage[`${_dataSourceName}${componentRefSplit}${fieldEntire}`] = realRef;
        }
        return (<formComponentMap.CnTreeSelect {...props} {...extraProps} ref={realRef}/>);
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, state, formProps, getFormInstance, } = config;
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            handleSelectRequestConfig({
                componentProps: componentProps,
                isDesign,
                urlParamsDataSource: urlParams,
                recordDataSource: formValue,
                state,
                ignoreHandleParam: true,
                handleDynamicUrl: true,
            });
            if (isPlainObject(componentProps?.multipleExtraProps)) {
                const { treeCheckable, treeCheckedStrategy } = componentProps?.multipleExtraProps;
                if (treeCheckable === true) {
                    componentProps.treeCheckable = true;
                    if (treeCheckedStrategy) {
                        componentProps.treeCheckedStrategy = treeCheckedStrategy;
                    }
                }
            }
            if (componentProps) {
                componentProps.getRequestParams = () => {
                    return {
                        urlParamsDataSource: urlParams,
                        recordDataSource: formValue,
                        state,
                        getFormInstance,
                    };
                };
                componentProps._dataSourceName = formProps?._dataSourceName;
                if (componentProps.requestConfig) {
                    handleRequestExtraConfig(componentProps.requestConfig, state);
                    const { method, serviceType, params, resultProcessFunc, headers } = componentProps.requestConfig;
                    const url = getRealRequestUrl({
                        requestConfig: componentProps.requestConfig,
                        state,
                    });
                    if (url) {
                        const requestConfig = { url, headers };
                        if (serviceType === 'mokelay') {
                            requestConfig.method = 'post';
                        }
                        else if (method) {
                            requestConfig.method = method;
                        }
                        requestConfig.formatParam = (oldParams) => {
                            const realParams = handleRequestParams(params, {
                                urlParamsDataSource: urlParams,
                                recordDataSource: formValue,
                                state,
                            });
                            return {
                                ...oldParams,
                                ...realParams,
                            };
                        };
                        if (typeof resultProcessFunc === 'function') {
                            requestConfig.formatResult = handleResultProcessFunc(componentProps.requestConfig);
                        }
                        componentProps.requestConfig = requestConfig;
                    }
                }
            }
            handleSelectDataSource({
                componentProps: componentProps,
                state,
            });
        }
    },
    filterItemBeforeHandler: (filterItemProps, config) => {
        handleSelectRequestConfig(config);
        if (isPlainObject(config?.componentProps?.multipleExtraProps)) {
            const { treeCheckable, treeCheckedStrategy } = config?.componentProps?.multipleExtraProps;
            if (treeCheckable === true) {
                config.componentProps.treeCheckable = true;
                if (treeCheckedStrategy) {
                    config.componentProps.treeCheckedStrategy = treeCheckedStrategy;
                }
            }
        }
        handleSelectDataSource(config);
    },
};
